import script from "./BannerOffline.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerOffline.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBanner});
